import React, { Component } from 'react';
import Table from 'react-bootstrap/Table';
import { CODE_DETAIL_ID } from '../../../../../constants/external-constants';
import { OrderRequestFiles } from '../request-details-files.component';
import { RequestOnBehalfDetails } from "../request-on-behalf-details.component";
import Translation from '../../../../common/translation/translation.component';

export class OrderQuotationDetails extends Component {
    constructor(props) {
        super(props);
    }

    renderPlanComponents = props => {
        return props != null && props.length != 0
            ? props.map((item, i) => (
                <tr key={i}>
                    <td>{i === 0 ? "Plan Details" : null}</td>
                    <td>{item.ComponentName}</td>
                </tr>
            ))
            : null;
    };

    render() {
        const { data } = this.props;
        return (
            <div>                
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" /></h4>
                <div className="order-detail-location">
                    <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} />
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="order_number" /></td>
                                <td>{data.Order.OrderNumber}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="capital_location" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="country" /></td>
                                <td>{data.Location.CountryName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="address" /></td>
                                <td>{data.Location.LocationName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="address_2_p2p" /></td>
                                <td>{data.LocationP2P != null ? data.LocationP2P.LocationName : ""}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="subscription_upper" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="circuit_id" /></td>
                                <td>{data.QuotationSubscription.QuotationCircuitId}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="vendor" /></td>
                                <td>{data.QuotationSubscription.Vendors.length > 0
                                    ? data.QuotationSubscription.Vendors.map(e => e.VendorName).join("; ")
                                    : ''}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="circuit_type" /></td>
                                <td>{data.QuotationSubscription.CircuitTypes.length > 0
                                    ? data.QuotationSubscription.CircuitTypes.map(e => e.DetailName).join("; ")
                                    : ''}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="contract_terms" /></td>
                                <td>{data.QuotationSubscription.ContractTerms.length > 0
                                    ? data.QuotationSubscription.ContractTerms.map(e => e.DetailName + " Months").join("; ")
                                    : ''}
                                </td>
                            </tr>
                            {data.QuotationSubscription.Bandwidth != null
                                && (data.QuotationSubscription.Bandwidth.length == 1
                                    && data.QuotationSubscription.Bandwidth[0].CodeDetailID == CODE_DETAIL_ID.Other ? false : true) &&
                                <tr>
                                    <td><Translation translationKey="bandwidth" /></td>
                                    <td>
                                        {data.QuotationSubscription.Bandwidth.map(e => e.CodeDetailID != CODE_DETAIL_ID.Other ? e.DetailName + " Mbps" : '').join("; ")}
                                    </td>
                                </tr>
                            }

                            {data.QuotationSubscription.BandwidthOther != null && data.QuotationSubscription.BandwidthOther !== '' &&
                                <tr>
                                    <td><Translation translationKey="bandwidth" /> (<Translation translationKey="other" />)</td>
                                    <td>
                                        {data.QuotationSubscription.BandwidthOther}
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="capital_business_justification" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="purpose_of_use" /></td>
                                <td>
                                    {data.BusinessJustification.PurposeOfUse}
                                </td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_justification" /></td>
                                <td>
                                    {data.BusinessJustification.BusinessJustification}
                                </td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="additional_information" /></td>
                                <td>
                                    {data.BusinessJustification.AdditionalInformation}
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    }
}